import React, { useMemo } from "react";
import { Title, Skeleton, Panel } from "components/commons";
import classnames from "classnames";
import lang from "translations";
import { useRouter } from "hooks";
import { mixpanel, TrackEvent } from "mixpanel";
import { Tooltip } from "components";

const ChartContainer = ({
  children,
  empty,
  error,
  title,
  emptyText,
  loading,
  className,
  h = "full",
  retry,
  paddingless,
  tooltipText,
}) => {
  const history = useRouter();

  const render = useMemo(() => {
    if (loading) {
      return (
        <Skeleton
          className={classnames({
            "pb-md": !paddingless,
            "pl-md": paddingless,
          })}
        />
      );
    }
    if (error) {
      return (
        <div
          className={classnames("flex text-sm py-lg cursor-pointer", {
            "pb-md": !paddingless,
            "pl-md": paddingless,
          })}
          onClick={() => {
            mixpanel.track(TrackEvent.ClickedButton, {
              Button: lang.retryReloadingChart,
              Page: lang.dashboard,
            });
            retry();
          }}
        >
          {lang.failedToLoad}
          <div className="flex text-sm ml-xs italic text-pelorous">{lang.clickHereToRetry}</div>
        </div>
      );
    }
    if (empty) {
      return (
        <div className={classnames(className, `h-${h}`, "flex items-center")}>
          <p
            className={classnames("text-sm text-gray-400", {
              "pb-xl": paddingless,
              "pb-md": !paddingless,
              "pl-md": paddingless,
            })}
          >
            {emptyText || lang.noDataAvailable}
          </p>
        </div>
      );
    }
    return children;
  }, [empty, error, children, emptyText, loading, retry, className, h, paddingless]);

  const renderTitle = useMemo(() => {
    if (tooltipText) {
      return (
        <div className="flex items-center">
          <Title
            md
            onClick={title.to ? () => history.push(title.to) : null}
            className={classnames("float-left", {
              "cursor-pointer": title.to,
            })}
          >
            {title.name ? title.name : title}
          </Title>
          <Tooltip
            className="cursor-pointer"
            title={tooltipText}
          >
            <span className="icon-warning text-gray-400 text-xs ml-xs"></span>
          </Tooltip>
        </div>
      )
    } else {
      return (
        <Title
          md
          onClick={title.to ? () => history.push(title.to) : null}
          className={classnames("float-left", {
            "cursor-pointer": title.to,
          })}
        >
          {title.name ? title.name : title}
        </Title>
      )
    }
  }, [history, title, tooltipText]);

  return (
    <Panel
      className={classnames(className, `h-${h}`)}
      mb="0"
      parent={false}
      paddingless={paddingless}
    >
      <div
        className={classnames(className, "flex", {
          "px-md": paddingless,
          "pt-md": paddingless,
        })}
      >
        {renderTitle}
      </div>
      {render}
    </Panel>
  );
};

export default ChartContainer;
